import styled from 'styled-components';

/**
 * Visually hides its content while keeping it available to assistive
 * technology — the standard "visually hidden" clip pattern. Use it to give
 * screen readers a plain-text equivalent of content whose visual rendering
 * is animated or fragmented (e.g. per-character glyph spans), or to add
 * screen-reader-only hints like "(opens in a new tab)".
 */
export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
`;
